import React, { Component } from 'react';
import { PageHeader, UnauthorizedMessage } from 'ui/components';

import './Unauthorized.scss';

export default class Unauthorized extends Component {
	render() {
		return (
			<div className="Unauthorized">
				<PageHeader />

				<UnauthorizedMessage />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/Unauthorized/index.js